import { BASE_PATH } from 'common/constants';

import { FINISHED_BONUS_DETAILS_SOURCE } from './finishedBonusDetailsShared';

const IMG_BASE = `${BASE_PATH}/static/assets/images`;

export const FINISHED_BONUS_PLACEHOLDER_SRC = {
  casino: `${IMG_BASE}/bonus-placeholder-casino.png`,
  freespin: `${IMG_BASE}/bonus-placeholder-freespin.png`,
  sport: `${IMG_BASE}/bonus-placeholder-sport.png`,
};

export const resolveFinishedBonusPlaceholderSrc = ({ bonus, sourceType } = {}) => {
  if (sourceType === FINISHED_BONUS_DETAILS_SOURCE.CLIENT_FREESPIN) {
    return FINISHED_BONUS_PLACEHOLDER_SRC.freespin;
  }

  if (sourceType === FINISHED_BONUS_DETAILS_SOURCE.CLIENT_BONUS) {
    const productType = bonus?.productType ?? bonus?.bonus?.productType;

    if (productType === 'SPORTSBOOK') {
      return FINISHED_BONUS_PLACEHOLDER_SRC.sport;
    }

    if (productType === 'CASINO') {
      return FINISHED_BONUS_PLACEHOLDER_SRC.casino;
    }
  }

  return null;
};
